import { Clickable } from '@carvana/merch-components';
import { useContext } from 'react';
import Tag from '@/SearchResults/ResultTile/Tags/Tag';
import useSendOpenModalEvent, {
  OpenSource
} from '@/SearchResults/ResultTileV2/useSendOpenModalEvent';
import MoreDetailsModalSections from '~/constants/MoreDetailsModalSections';
import ModalContext from '~/contexts/ModalContext';
import { useVehicleContext } from '~/contexts/VehicleContext';
import usePriceDrop from '~/hooks/usePriceDrop';

const NewPriceTag = () => {
  const { vehicle } = useVehicleContext();
  const { setMoreDetailsModalOpen } = useContext(ModalContext);
  const sendOpenEvent = useSendOpenModalEvent();
  const { displayText } = usePriceDrop();

  return (
    <Clickable
      data-qa="new-price-badge"
      data-analytics-id={null}
      className="pointer-events-auto"
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        sendOpenEvent(OpenSource.NewPrice);
        setMoreDetailsModalOpen(true, {
          openTo: MoreDetailsModalSections.NewPrice,
          vehicleId: vehicle.vehicleId
        });
      }}
    >
      <Tag text={displayText} bgColor="bg-green-2" />
    </Clickable>
  );
};

export default NewPriceTag;
